export class EmptyTextureProcessor {
    addTexture(texture) {
    }
    onUpdate() {
    }
    shouldAddToDynamicAtlas(texture) {
        return false;
    }
    cleanupUnused() {
    }
}
